import React from 'react';
import { Link } from '@/i18n/navigation';
import Image from 'next/image';

export function Logo() {
  return (
    <Link href="/" className="block">
      <Image
        src="/logos/fpc logo.png"
        alt="Future Proof Commodities"
        width={180}
        height={60}
        className="h-auto w-auto max-h-12"
        priority
      />
    </Link>
  );
}

export default Logo;
